import React, { useState } from 'react';
import { View, Pressable } from 'react-native';

import SubmitUrl from '~/client/components/SubmitUrl';
import SearchAppleMusic from '~/client/components/SearchAppleMusic';
import ImportAppleMusicFavorites from '~/client/components/ImportAppleMusicFavorites';
import Text from '~/client/components/Text';

import { RecentSubmission } from '~/client/types';

export type TRecentAlbums = RecentSubmission[];

export enum TAB_NAMES {
  SUBMIT_URL = 'submit_url',
  SEARCH_APPLE_MUSIC = 'search_apple_music',
  IMPORT_APPLE_MUSIC_FAVORITES = 'import_apple_music_favorites',
}

function Tab({
  active,
  onPress,
  children,
  tabName,
}: {
  active: boolean;
  onPress: () => void;
  children: React.ReactNode;
  tabName: TAB_NAMES;
}) {
  return (
    <Pressable onPress={onPress} style={{ marginRight: 16 }}>
      <Text
        style={{
          textDecoration: active ? 'underline' : '',
        }}
      >
        {children}
      </Text>
    </Pressable>
  );
}

export default function ActionBar({
  recentAlbums,
}: {
  recentAlbums: TRecentAlbums;
}) {
  const [activeTab, setActiveTab] = useState<TAB_NAMES>(TAB_NAMES.SUBMIT_URL);
  return (
    <View className="p-4 bg-white drop-shadow rounded-sm dark:bg-gray-800">
      <View className="flex-row">
        <Tab
          tabName={TAB_NAMES.SUBMIT_URL}
          onPress={() => {
            setActiveTab(TAB_NAMES.SUBMIT_URL);
          }}
          active={activeTab === TAB_NAMES.SUBMIT_URL}
        >
          Add Links
        </Tab>
        <Tab
          tabName={TAB_NAMES.SEARCH_APPLE_MUSIC}
          onPress={() => {
            setActiveTab(TAB_NAMES.SEARCH_APPLE_MUSIC);
          }}
          active={activeTab === TAB_NAMES.SEARCH_APPLE_MUSIC}
        >
          Search Apple Music
        </Tab>
        <Tab
          tabName={TAB_NAMES.IMPORT_APPLE_MUSIC_FAVORITES}
          onPress={() => {
            setActiveTab(TAB_NAMES.IMPORT_APPLE_MUSIC_FAVORITES);
          }}
          active={activeTab === TAB_NAMES.IMPORT_APPLE_MUSIC_FAVORITES}
        >
          Import Favorites
        </Tab>
      </View>

      <SubmitUrl
        active={activeTab === TAB_NAMES.SUBMIT_URL}
        mostRecentSubmission={recentAlbums[0]}
      />
      <SearchAppleMusic active={activeTab === TAB_NAMES.SEARCH_APPLE_MUSIC} />
      <ImportAppleMusicFavorites
        active={activeTab === TAB_NAMES.IMPORT_APPLE_MUSIC_FAVORITES}
      />
    </View>
  );
}
